// src/components/ImageModal.js
import React from "react";
import "./ImageModal.css";

export default function ImageModal({ isOpen, onClose, src, alt }) {
  if (!isOpen) return null;

  return (
    <div className="image-modal-overlay" onClick={onClose}>
      <div
        className="image-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="image-modal-close-button app-cancel-control" onClick={onClose}>
          ✖
        </button>
        <img src={src} alt={alt || "Attached image"} className="image-modal-img" />
      </div>
    </div>
  );
}
